export default __webpack_public_path__ + "static/media/Icon_Card_01.eea1f586.png";